import React from "react";

function Contact() {
  return (
    <div className="contact section">
      <h2 className="termsHeader">Contact Us</h2>
      <p className="termsText">
        You can get in touch via email: contact.gistgate@gmail.com <br /> <br />{" "}
        Follow on Twitter @gistgate <br /> <br /> Whatsapp: +2347035719745
      </p>
    </div>
  );
}

export default Contact;
